'use strict';
var CartWidget, LanguageSelector, SignInFlyout, User, addReferrer, appendLanguageMenu, fetchUser, my_stuff_layout_template, my_stuff_menu_template, removeCachedUserData, setCartWidget, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_menu_template = require('../my_stuff_menu.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

CartWidget = require('../../../../cart_widget/frontend/cart_widget');

SignInFlyout = require('../../signin_flyout/frontend/signin_flyout');

LanguageSelector = require('../../language_menu/frontend/language_selector');


/**
 * @public
 */

removeCachedUserData = function() {
  return fetchUser.removeUserData();
};

setCartWidget = function() {
  if ($('#ls-user-nav .cart-widget').length) {
    return new CartWidget('.cart-widget');
  }
};

appendLanguageMenu = function(hasUser) {
  var $container, $langMenu;
  $langMenu = $('#ls-lang-menu').removeClass('ls-hide');
  if (!$langMenu.length) {
    return;
  }
  new LanguageSelector();
  if (!$('.big-searchbar').length) {
    return;
  }
  $container = $('#ls-user-nav .user-menu');
  if (hasUser) {
    return $langMenu.insertBefore('#user-name');
  } else {
    return $container.append($langMenu);
  }
};

User = {
  init: function() {
    var ref, ref1;
    if (!$('#ls-user-nav').length) {
      return;
    }
    this.showSigninFlyout = (ref = Groupon.LS.flags) != null ? ref.showSigninFlyout : void 0;
    this.translations = (ref1 = Groupon.LS.translations) != null ? ref1.userNav : void 0;
    this.country_US = document.head.getAttribute('data-country') === 'US';
    this.isLivingSocial = document.head.getAttribute('data-brand') === 'livingsocial';
    this.fetchWithTokenExchange();
    if (this.showSigninFlyout) {
      SignInFlyout.init();
      return this.renderMyStuffMenu(null, 'ls-signin-flyout-mystuff-pane');
    }
  },
  fetchWithTokenExchange: function() {
    return fetchUser.exchangeTokenIfNeed(((function(_this) {
      return function() {
        return _this.fetch();
      };
    })(this)));
  },
  fetch: function() {
    var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
    noUser_cb = function() {
      addReferrer.init();
      setCartWidget();
      appendLanguageMenu(false);
    };
    hasUser_cb = (function(_this) {
      return function(res) {
        _this.renderUserNav(res);
        _this.renderMyStuff(res);
        Groupon.Modules.Header.bind();
        delete Groupon.Modules.Header;
        setCartWidget();
        appendLanguageMenu(true);
      };
    })(this);
    success = hasUser_cb;
    ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
    if (hasUserData || !userId) {
      return;
    }
    error = function(err) {
      Groupon.Utils.trackEvent('user-call-failed', err);
    };
    return fetchUser.fetch(userId, success, error);
  },
  loadViewData: function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return {
      t: this.translations,
      country_US: this.country_US,
      showSigninFlyout: this.showSigninFlyout,
      showLiteHeader: $('#ls-lite-header').length != null,
      enableBigSearch: $('.big-searchbar').length != null,
      showWishlist: ((ref = Groupon.LS.flags) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
      showMerchantLinkHeader: (ref1 = Groupon.LS.flags) != null ? ref1.showMerchantLinkHeader : void 0,
      showReferAFriend: (ref2 = Groupon.LS.flags) != null ? ref2.showReferAFriend : void 0,
      referAFriendMessage: (ref3 = Groupon.LS.flags) != null ? ref3.referAFriendMessage : void 0,
      showMerchantCenterLink: (ref4 = Groupon.LS.flags) != null ? ref4.showMerchantCenterLink : void 0,
      showGiftCards: (ref5 = Groupon.LS.flags) != null ? ref5.showGiftCards : void 0,
      showMyProfile: (ref6 = Groupon.LS.flags) != null ? ref6.showMyProfile : void 0,
      showCart: (ref7 = Groupon.Cart) != null ? ref7.showCart : void 0
    };
  },
  renderMyStuffMenu: function(user, containerId) {
    var data, ref;
    data = Object.assign({}, this.loadViewData(), {
      user: user
    });
    data.profileLink = ((ref = data.t) != null ? ref.myProfileLink : void 0) || '/myprofile';
    if (!user) {
      data.profileLink = "/login?ref=" + (encodeURIComponent(data.profileLink));
    }
    return $('#' + containerId).html(my_stuff_menu_template.render(data));
  },
  renderUserNav: function(user) {
    var data, ref, ref1;
    data = Object.assign({}, this.loadViewData(), {
      user: user
    });
    $('#ls-user-nav').html(user_nav_template.render(data));
    this.renderMyStuffMenu(user, 'ls-my-stuff');
    addReferrer.init();
    if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
      $('#user-my-page').removeClass('hidden');
    }
    if ((ref1 = Groupon.PageFlags) != null ? ref1.isLegacyResponsive : void 0) {
      new Groupon.LS.Header.PNResponsiveMenu;
    }
    $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
  },
  renderMyStuff: function(user) {
    var $myStuffSelector, current, data, ref, ref1, ref2, ref3;
    if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
      return;
    }
    current = Groupon.LS.CurrentMyStuffApp;
    data = {
      current: current,
      user: user,
      t: this.translations,
      country_US: this.country_US,
      isLivingSocial: this.isLivingSocial,
      showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
      showMyLinkedDealsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyLinkedDealsTab : void 0,
      showMyReservationsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyReservationsTab : void 0,
      showMyProfile: (ref3 = Groupon.LS.flags) != null ? ref3.showMyProfile : void 0
    };
    return $myStuffSelector.html(my_stuff_layout_template.render(data));
  }
};

Groupon.LS.User = {
  removeCachedUserData: removeCachedUserData
};

module.exports = {
  User: User
};

